import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import BackBtn from 'components/buttons/BackBtn'
import { useHistory } from 'react-router-dom'
import Popup from 'components/popups/Popup'
import { displayPrice } from 'utils/string'
import React, { useState } from 'react'
import Range from 'components/Range'

interface InsurancePopupProps {
  data: AvailableInsurance
  previousValues?: InsuranceState
  updateValues: (values: InsuranceState) => void
}

export interface InsuranceState {
  v: string
  variantId: string
  variantName: string
  grossPrice: string
}

interface AvailableInsurance {
  variants: AvailableInsuranceVariant[]
}

interface AvailableInsuranceVariant {
  id: string
  name: string
  selected: boolean
  description: string
  pricelist: AvailableInsurancePricelist[]
}

interface AvailableInsurancePricelist {
  gross_price: string
  v: string
  r: number
}

const InsurancePopup: React.FC<InsurancePopupProps> = ({ previousValues, data, updateValues }) => {
  const selectedVariant = data?.variants?.find(v => v.selected) || data?.variants?.[0]
  const [values, setValues] = useState<InsuranceState>(previousValues || {
    variantId: selectedVariant?.id,
    variantName: selectedVariant?.name,
    v: selectedVariant.pricelist?.[1] ? selectedVariant.pricelist[1]?.v : selectedVariant.pricelist?.[0]?.v,
    grossPrice: selectedVariant.pricelist?.[1] ? selectedVariant.pricelist[1]?.gross_price : selectedVariant.pricelist?.[0]?.gross_price
  })

  const { t } = useTranslation('basket')
  const { goBack } = useHistory()

  const priceListData = selectedVariant?.pricelist.reduce((r, priceListItem) => {
    r.options.push(priceListItem.v)
    r.optionsPosition.push(priceListItem.r)
    return r
  }, {
    options: [] as string[],
    optionsPosition: [] as number[]
  })

  return (
    <Popup darkBg>
      <div className='insurance__popup'>
        <p>{t('insuranceOptions')}</p>
        <div className='insurance__options'>
          {data.variants.map(({ id, name, description, pricelist }) => {
            const isSelected = values.variantId === id
            return <div
              key={id}
              className={`insurance__option${isSelected ? ' --selected' : ''}`}
              onClick={() => {
                if (isSelected) return
                const priceListItem = pricelist?.[1] || pricelist?.[0]
                setValues({
                  variantId: id,
                  variantName: name,
                  v: priceListItem?.v,
                  grossPrice: priceListItem?.gross_price
                })
              }}>
              <div className='insurance__option__title'>{name}</div>
              <div className='insurance__option__desc'>{description}</div>
              <div className='insurance__option__circle'>
                <i className='icon icon--check' />
              </div>
            </div>
          })}
        </div>

        <p>{t('insuranceSum')}: {displayPrice(values.v)}</p>
        <Range
          value={values.v}
          options={priceListData.options as never[]} // 🙈
          optionsPosition={priceListData.optionsPosition as never[]} // 🙈
          updateValue={(v: string) => {
            const grossPrice = selectedVariant.pricelist.find(e => e.v === v)?.gross_price || ''
            setValues(prev => ({ ...prev, v, grossPrice }))
          }}
        />

        <div className='insurance__buttons'>
          <ArrowBtn
            enlarged
            showArrow={false}
            text={`${t('add')} (${t('monthly')} ${displayPrice(values.grossPrice)})`}
            action={() => {
              updateValues(values)
              goBack()
            }}
          />
          <BackBtn
            text={t('downloadTAndC')}
            action={() => {
              alert('OWU')
            }}
          />
        </div>
      </div>
    </Popup>
  )
}

export default InsurancePopup